import React, { Fragment, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./layout";
import { MENU_SLUG } from "./constants/constants";
import SettingIcon from "./icons/settingIcon";
import ImgFillIcon from "./icons/imgFillIcon";
import ToolsIcon from "./icons/toolsIcon";
import ReportIcon from "./icons/reportIcon";
import CalendarIcon from "./icons/calendarIcon";
import Snapshot from "./pages/snapshot";
import ServiceHistory from "./pages/serviceHistory";
import TrackDays from "./pages/trackDays";
import Report from "./pages/report";
import MyConsumables from "./pages/setUpConsumables";
import Tutorials from "./pages/tutorials";
import Billing from "./pages/billing";
import ContactUs from "./pages/contactUs";
import MyCars from "./pages/myCars";
import Login from "./pages/login";
import SignUp from "./pages/signUp";
import ForgotPassword from "./pages/forgotPassword";
import { useAuth } from "./hooks/useAuth";
import useLogout from "./hooks/useLogout";
import PersistLogin from "./auth/PersistLogin";
import history from "./utils/history";
import Profile from "./pages/profile";
import Checklist from "./pages/checklist";
function App() {
  const { auth, persist } = useAuth();
  let monitorBy =
    auth?.monitorBy?.charAt(0).toUpperCase() + auth?.monitorBy?.slice(1);

  if (monitorBy === "Days") {
    monitorBy = "Days";
  } else if (monitorBy === "Sessions") {
    monitorBy = "Sessions";
  } else if (monitorBy === "Laps") {
    monitorBy = "Miles";
  }

  const logout = useLogout();

  const signOut = async () => {
    await logout();
  };

  const pages = [
    {
      name: "profile",
      title: "Profile",
      link: `/${MENU_SLUG.profile}`,
      path: `/${MENU_SLUG.profile}`,
      component: Profile,
      show_tab: false,
    },
    {
      name: "my_cars",
      title: "My Cars",
      link: `/${MENU_SLUG.my_cars}`,
      path: `/${MENU_SLUG.my_cars}`,
      component: MyCars,
      show_tab: false,
    },
    {
      name: "snapshot",
      title: "Snapshot",
      link: `/${MENU_SLUG.snapshot}`,
      path: `/${MENU_SLUG.snapshot}`,
      component: Snapshot,
      show_tab: true,
      icon: ImgFillIcon,
    },
    {
      name: "service_history",
      title: "Service History",
      link: `/${MENU_SLUG.service_history}`,
      path: `/${MENU_SLUG.service_history}`,
      component: ServiceHistory,
      show_tab: true,
      icon: ToolsIcon,
    },
    {
      name: "track",
      title: `Track ${monitorBy}`,
      link: `/${MENU_SLUG.track}`,
      path: `/${MENU_SLUG.track}`,
      component: TrackDays,
      show_tab: true,
      icon: CalendarIcon,
    },
    {
      name: "reports",
      title: "Reports",
      link: `/${MENU_SLUG.reports}`,
      path: `/${MENU_SLUG.reports}`,
      component: Report,
      show_tab: true,
      icon: ReportIcon,
    },
    {
      name: "utilities",
      title: "Utilities",
      link: `/${MENU_SLUG.utilities}`,
      path: `/${MENU_SLUG.utilities}`,
      component: MyConsumables,
      show_tab: true,
      icon: SettingIcon,
      children: [
        {
          name: "set_up_consumables",
          title: "Set Up Consumables",
          link: `/${MENU_SLUG.set_up_consumables}`,
          path: `/${MENU_SLUG.set_up_consumables}`,
          show_tab: true,
          component: MyConsumables,
        },
        {
          name: "checklist",
          title: "Checklist",
          link: `/${MENU_SLUG.checklist}`,
          path: `/${MENU_SLUG.checklist}`,
          show_tab: true,
          component: Checklist,
        },
        {
          name: "tutorials",
          title: "Tutorials",
          link: `/${MENU_SLUG.tutorials}`,
          path: `/${MENU_SLUG.tutorials}`,
          show_tab: true,
          component: Tutorials,
        },
        {
          name: "billing",
          title: "Billing",
          link: `/${MENU_SLUG.billing}`,
          path: `/${MENU_SLUG.billing}`,
          show_tab: true,
          component: Billing,
        },
        {
          name: "contact_us",
          title: "Contact Us",
          link: `/${MENU_SLUG.contact_us}`,
          path: `/${MENU_SLUG.contact_us}`,
          show_tab: true,
          component: ContactUs,
        },
        {
          name: "logout",
          title: "Logout",
          show_tab: true,
          onClick: signOut,
        },
      ],
    },
  ];

  const lastHistory = history.location.pathname;

  useEffect(() => {
    localStorage.clear()
    sessionStorage.clear()
    const sRememberMe = document.cookie
      .split("; ")
      ?.find((row) => row.startsWith("remember_me="))
      ?.split("=")[1];
    if (!sRememberMe) {
      const lRememberMe = localStorage.getItem("remember_me");
      if (lRememberMe === "false") {
        signOut();
      }
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Routes>
      <Route element={<PersistLogin />}>
        {auth.token && persist ? (
          <Fragment>
            <Route
              path="/"
              element={<Layout pages={pages} lastVisitedRoute={lastHistory} />}
            >
              {pages.map((page, index) => (
                <Fragment key={index}>
                  <Route
                    key={index}
                    path={page.path}
                    element={<page.component />}
                  />
                  {page.children &&
                    page.children.map(
                      (child, index) =>
                        child.path && (
                          <Route
                            key={index}
                            path={`${page.path}${child.path}`}
                            element={<child.component />}
                          />
                        )
                    )}
                </Fragment>
              ))}
            </Route>
            <Route
              path={"*"}
              element={<Navigate to={`/${MENU_SLUG.snapshot}`} replace />}
            />
          </Fragment>
        ) : (
          <Fragment>
            <Route path={`/${MENU_SLUG.login}`} element={<Login />} />
            <Route path={`/${MENU_SLUG.sign_up}`} element={<SignUp />} />
            <Route
              path={`/${MENU_SLUG.forgot_password}`}
              element={<ForgotPassword />}
            />
            <Route
              path={"*"}
              element={<Navigate to={`/${MENU_SLUG.login}`} replace />}
            />
          </Fragment>
        )}
      </Route>
    </Routes>
  );
}

export default App;
